import { select_company } from "./Company.type";

export const companyReducer = (state, { type, payload }) => {
  switch (type) {
    case select_company: {
      return {
        ...state,
        name: payload,
      };
    }
    default:
      return state;
  }
};
